import { motion } from 'motion/react'
import React, { createContext, ReactNode, useContext, useEffect, useState } from 'react'

import { NavLink } from '@src/navigation/nav-link.component'

type TabContextValue = {
  onChange?: (id: string | number) => void
  value?: string | number
  block?: boolean
}

type TabsProps = {
  value?: string | number
  block?: boolean
  onChange?: (id: string | number) => void
  className?: string
  children: ReactNode
}

const TabContext = createContext<TabContextValue>({})

export function Tabs(props: TabsProps) {
  const { value, block, children, className, onChange } = props

  return (
    <TabContext.Provider value={{ onChange, value, block }}>
      <div
        className={`inline-flex flex-wrap bg-primary/10 rounded-full ${block ? 'w-full' : ''} ${className || ''}`}
      >
        {children}
      </div>
    </TabContext.Provider>
  )
}

/** Tab button **/
Tabs.Button = function TabButton({ children, id, ...rest }: { children: ReactNode; id?: string | number } & React.ButtonHTMLAttributes<HTMLButtonElement>) {
  const { onChange, value, block } = useContext(TabContext)
  const isActive = id && value === id

  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    setIsFirstRender(false)
  }, [])

  return (
    <button
      className={`relative flex-1 px-4 h-16 font-medium cursor-pointer text-center inline-flex items-center justify-center z-0 transition-all rounded-full hover:bg-primary/15 focus:outline-hidden ${isActive ? 'font-bold text-white' : ''} ${block ? 'w-full' : ''}`}
      onClick={() => onChange?.(id!)}
      {...rest}
    >
      {isActive && !isFirstRender && (
        <motion.span
          layoutId="bubble"
          className="absolute inset-0 z-10 bg-primary mix-blend-difference rounded-full"
          initial={false}
          transition={{ type: 'spring', bounce: 0.2, duration: 0.5 }}
        />
      )}
      <span className="z-20">{children}</span>
    </button>
  )
}

/** Link Tab **/
Tabs.Link = function LinkTab({ children, to, ...rest }: { children: ReactNode; to: string } & Record<string, any>) {
  const { block } = useContext(TabContext)
  const [isFirstRender, setIsFirstRender] = useState(true)

  useEffect(() => {
    setIsFirstRender(false)
  }, [])

  return (
    <NavLink
      className={`relative flex-1 px-4 h-16 font-medium cursor-pointer text-center inline-flex items-center justify-center z-0 transition-all rounded-full hover:bg-primary/15 focus:outline-hidden ${block ? 'w-full' : ''}`}
      activeClassName="font-bold text-white"
      name={children as string}
      to={to}
      {...rest}
    >
      {({ isActive }) => {
        console.log(children, isActive)
        return (
          <>
            {isActive && !isFirstRender && (
              <motion.span
                initial={false}
                layoutId="bubble"
                className="absolute inset-0 z-10 bg-primary rounded-full"
                transition={{ type: 'spring', bounce: 0.2, duration: 0.5 }}
              />
            )}
            <span className="z-20">{children}</span>
          </>
        )
      }}
    </NavLink>
  )
}
